// extracted by mini-css-extract-plugin
export default {"iconContainer":"DesktopApplicationIcon_iconContainer__90T2D","applicationFavicon":"DesktopApplicationIcon_applicationFavicon__sGzsX"};